import { type ReactElement } from 'react';
import { MaterialIcon } from '@lapo/ui';
import { PageType } from '@lapo/core';
import { noteEmoji } from './noteIndex.js';

/**
 * Render a note's list icon consistently everywhere it appears (Library, search, sidebar): the page's
 * own icon when set — an emoji, or a "material:name" rendered as a Material Symbol — otherwise the
 * generic per-type emoji (📄 / 📓). Keeping this in one place is why setting an icon in the ⋯ menu now
 * shows up across all the surfaces.
 */
export function NoteIcon({
  icon,
  type,
  size = 18,
}: {
  icon?: string | null;
  type: PageType;
  size?: number;
}): ReactElement {
  if (icon && icon.startsWith('material:')) return <MaterialIcon name={icon.slice('material:'.length)} size={size} />;
  return <>{icon || noteEmoji(type)}</>;
}
